import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-shopify-accounting-entries-file-exporter-configuration',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './shopify-ae-file-exporter-configuration.component.html',
  styleUrls: ['./shopify-ae-file-exporter-configuration.component.scss']
})
export class ShopifyAccountingEntriesFileExporterConfigurationComponent {
  formGroup: FormGroup;

  constructor(
    readonly fb: FormBuilder

  ) {
    this.formGroup = fb.group({});
  }
}